module.exports = __webpack_public_path__ + "static/media/background.f9f4d92d.jpg";